import { render, staticRenderFns } from "./NoteSolutionModal.vue?vue&type=template&id=6581ec88&scoped=true"
import script from "./NoteSolutionModal.vue?vue&type=script&lang=js"
export * from "./NoteSolutionModal.vue?vue&type=script&lang=js"
import style0 from "./NoteSolutionModal.vue?vue&type=style&index=0&id=6581ec88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581ec88",
  null
  
)

export default component.exports